var Scale = require('@antv/scale/lib/base');

require('@antv/scale/lib/linear');
require('@antv/scale/lib/identity');
require('@antv/scale/lib/category');

module.exports = Scale;